<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ETABLISSEMENT_IDENTITE')">
        <slot name="section-etablissement-identite">
          <section-etablissement-identite ref="ETABLISSEMENT_IDENTITE"
                                          id="ETABLISSEMENT_IDENTITE"
                                          :extended="isExtended('ETABLISSEMENT_IDENTITE')"
                                          :showButton="true"
                                          :autoSave="true"
                                          :readOnly="readOnly"
                                          :moduleId="moduleId"
                                          :searchText="searchText"
                                          :ressourceHeader="ressource"
                                          :fiche="fiche"
                                          :toggleResetFormeJuridiqueSelect="toggleResetFormeJuridiqueSelect"
                                          :toggleResetBrancheSelect="toggleResetBrancheSelect"
                                          :toggleResetConventionBrancheList="toggleResetConventionBrancheList"
                                          :toggleResetTrancheEffectifSelect="toggleResetTrancheEffectifSelect"
                                          :etablissement=selectedEtablissement
                                          :route="route"
                                          :attribut="attribut"
                                          @extended="setExtended"
                                          @fullscreen="setFullscreen"
                                          @status="updateStatus"
                                          @updated="etablissementUpdated"
                                          @selectItem = "selectItem">
          </section-etablissement-identite>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ADRESSE')">
        <slot name="section-adresse">
          <section-adresse ref="ADRESSE"
                           id="ADRESSE"
                           :extended="isExtended('ADRESSE')"
                           :showButton="true"
                           :autoSave="true"
                           :readOnly="readOnly"
                           :moduleId="moduleId"
                           :searchText="searchText"
                           :ressourceHeader="ressource"
                           :fiche="fiche"
                           :toggleResetPaysSelect="toggleResetPaysSelect"
                           :adresse=selectedAdresse
                           :route="route"
                           :attribut="attribut"
                           @extended="setExtended"
                           @fullscreen="setFullscreen"
                           @status="updateStatus"
                           @updated="adresseUpdated"
                           @selectItem = "selectItem">
          </section-adresse>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ETABLISSEMENT_CONTACTS')">
        <slot name="section-etablissement-contacts">
          <section-etablissement-contacts ref="ETABLISSEMENT_CONTACTS"
                                          id="ETABLISSEMENT_CONTACTS"
                                          :extended="isExtended('ETABLISSEMENT_CONTACTS')"
                                          :showButton="true"
                                          :autoSave="true"
                                          :readOnly="readOnly"
                                          :moduleId="moduleId"
                                          :searchText="searchText"
                                          :ressourceHeader="ressource"
                                          :fiche="fiche"
                                          :etablissement=selectedEtablissement
                                          :route="route"
                                          :attribut="attribut"
                                          @extended="setExtended"
                                          @fullscreen="setFullscreen"
                                          @status="updateStatus"
                                          @updated="etablissementUpdated"
                                          @selectItem = "selectItem">
          </section-etablissement-contacts>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ETABLISSEMENT_AFFILIATIONS')">
        <slot name="section-etablissement-affiliations">
          <section-etablissement-affiliations ref="ETABLISSEMENT_AFFILIATIONS"
                                              id="ETABLISSEMENT_AFFILIATIONS"
                                              :extended="isExtended('ETABLISSEMENT_AFFILIATIONS')"
                                              :showButton="true"
                                              :autoSave="true"
                                              :readOnly="readOnly"
                                              :moduleId="moduleId"
                                              :searchText="searchText"
                                              :ressourceHeader="ressource"
                                              :fiche="fiche"
                                              :etablissement=selectedEtablissement
                                              :route="route"
                                              :attribut="attribut"
                                              @extended="setExtended"
                                              @fullscreen="setFullscreen"
                                              @status="updateStatus"
                                              @updated="etablissementUpdated"
                                              @selectItem = "selectItem">
          </section-etablissement-affiliations>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ETABLISSEMENT_CAISSES')">
        <slot name="section-etablissement-caisses">
          <section-etablissement-caisses ref="ETABLISSEMENT_CAISSES"
                                         id="ETABLISSEMENT_CAISSES"
                                         :extended="isExtended('ETABLISSEMENT_CAISSES')"
                                         :showButton="true"
                                         :autoSave="true"
                                         :readOnly="readOnly"
                                         :moduleId="moduleId"
                                         :searchText="searchText"
                                         :ressourceHeader="ressource"
                                         :fiche="fiche"
                                         :toggleResetCaisseSelectComplementaire="toggleResetCaisseSelectComplementaire"
                                         :etablissement=selectedEtablissement
                                         :route="route"
                                         :attribut="attribut"
                                         @extended="setExtended"
                                         @fullscreen="setFullscreen"
                                         @status="updateStatus"
                                         @updated="etablissementUpdated"
                                         @selectItem = "selectItem">
          </section-etablissement-caisses>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('DEMANDE_ATTESTATION_LIST')">
        <slot name="section-demande-attestation-list">
          <section-demande-attestation-list ref="DEMANDE_ATTESTATION_LIST"
                                            id="DEMANDE_ATTESTATION_LIST"
                                            :extended="isExtended('DEMANDE_ATTESTATION_LIST')"
                                            :showButton="true"
                                            :autoSave="true"
                                            :readOnly="readOnly"
                                            :moduleId="moduleId"
                                            :searchText="searchText"
                                            :ressourceHeader="ressource"
                                            :fiche="fiche"
                                            :etablissement=selectedEtablissement
                                            :route="route"
                                            :attribut="attribut"
                                            @extended="setExtended"
                                            @fullscreen="setFullscreen"
                                            @status="updateStatus"
                                            @toggleCardView="toggleCardView"
                                            @updated="attestationUpdated"
                                            @selectItem = "selectItem">
          </section-demande-attestation-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ACCIDENT_TRAVAIL_LIST')">
        <slot name="section-accident-travail-list">
          <section-accident-travail-list ref="ACCIDENT_TRAVAIL_LIST"
                                         id="ACCIDENT_TRAVAIL_LIST"
                                         :extended="isExtended('ACCIDENT_TRAVAIL_LIST')"
                                         :showButton="true"
                                         :autoSave="true"
                                         :readOnly="readOnly"
                                         :moduleId="moduleId"
                                         :searchText="searchText"
                                         :ressourceHeader="ressource"
                                         :fiche="fiche"
                                         :etablissement=selectedEtablissement
                                         :route="route"
                                         :attribut="attribut"
                                         @extended="setExtended"
                                         @fullscreen="setFullscreen"
                                         @status="updateStatus"
                                         @toggleCardView="toggleCardView"
                                         @updated="accidentTravailUpdated"
                                         @selectItem = "selectItem">
          </section-accident-travail-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('GESTIONNAIRES_PAIE')">
        <slot name="section-gestionnaires-paie">
          <section-gestionnaires-paie ref="GESTIONNAIRES_PAIE"
                                      id="GESTIONNAIRES_PAIE"
                                      :extended="isExtended('GESTIONNAIRES_PAIE')"
                                      :showButton="true"
                                      :autoSave="true"
                                      :readOnly="readOnly"
                                      :moduleId="moduleId"
                                      :searchText="searchText"
                                      :ressourceHeader="ressource"
                                      :fiche="fiche"
                                      :etablissement=selectedEtablissement
                                      :route="route"
                                      :attribut="attribut"
                                      @extended="setExtended"
                                      @fullscreen="setFullscreen"
                                      @status="updateStatus"
                                      @updated="etablissementUpdated"
                                      @selectItem = "selectItem">
          </section-gestionnaires-paie>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('APPRENTI_LIST')">
        <slot name="section-apprenti-list">
          <section-apprenti-list ref="APPRENTI_LIST"
                                 id="APPRENTI_LIST"
                                 :extended="isExtended('APPRENTI_LIST')"
                                 :showButton="true"
                                 :autoSave="true"
                                 :readOnly="readOnly"
                                 :moduleId="moduleId"
                                 :searchText="searchText"
                                 :ressourceHeader="ressource"
                                 :fiche="fiche"
                                 :etablissement=selectedEtablissement
                                 :route="route"
                                 :attribut="attribut"
                                 @extended="setExtended"
                                 @fullscreen="setFullscreen"
                                 @status="updateStatus"
                                 @toggleCardView="toggleCardView"
                                 @updated="apprentiUpdated"
                                 @selectItem = "selectItem">
          </section-apprenti-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('PAYMENT_MEANS_LIST')">
        <slot name="section-payment-means-list">
          <section-payment-means-list ref="PAYMENT_MEANS_LIST"
                                      id="PAYMENT_MEANS_LIST"
                                      :extended="isExtended('PAYMENT_MEANS_LIST')"
                                      :showButton="true"
                                      :autoSave="true"
                                      :readOnly="readOnly"
                                      :moduleId="moduleId"
                                      :searchText="searchText"
                                      :ressourceHeader="ressource"
                                      :fiche="fiche"
                                      :owner=owner
                                      :etablissement=selectedEtablissement
                                      :route="route"
                                      :attribut="attribut"
                                      @extended="setExtended"
                                      @fullscreen="setFullscreen"
                                      @status="updateStatus"
                                      @toggleCardView="toggleCardView"
                                      @selectItem = "selectItem">
          </section-payment-means-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ABONNEMENT')">
        <slot name="section-abonnement">
          <section-abonnement ref="ABONNEMENT"
                              id="ABONNEMENT"
                              :extended="isExtended('ABONNEMENT')"
                              :showButton="true"
                              :autoSave="true"
                              :readOnly="readOnly"
                              :moduleId="moduleId"
                              :searchText="searchText"
                              :ressourceHeader="ressource"
                              :fiche="fiche"
                              :etablissement=selectedEtablissement
                              :route="route"
                              :attribut="attribut"
                              @extended="setExtended"
                              @fullscreen="setFullscreen"
                              @status="updateStatus"
                              @updated="etablissementUpdated"
                              @selectItem = "selectItem">
          </section-abonnement>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('PRELEV_MEANS')">
        <slot name="section-prelev-means">
          <section-prelev-means ref="PRELEV_MEANS"
                                id="PRELEV_MEANS"
                                :extended="isExtended('PRELEV_MEANS')"
                                :showButton="true"
                                :autoSave="true"
                                :readOnly="readOnly"
                                :moduleId="moduleId"
                                :searchText="searchText"
                                :ressourceHeader="ressource"
                                :fiche="fiche"
                                :etablissement=selectedEtablissement
                                :route="route"
                                :attribut="attribut"
                                @extended="setExtended"
                                @fullscreen="setFullscreen"
                                @status="updateStatus"
                                @updated="etablissementUpdated"
                                @selectItem = "selectItem">
          </section-prelev-means>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('SALAIRE_MEANS')">
        <slot name="section-salaire-means">
          <section-salaire-means ref="SALAIRE_MEANS"
                                 id="SALAIRE_MEANS"
                                 :extended="isExtended('SALAIRE_MEANS')"
                                 :showButton="true"
                                 :autoSave="true"
                                 :readOnly="readOnly"
                                 :moduleId="moduleId"
                                 :searchText="searchText"
                                 :ressourceHeader="ressource"
                                 :fiche="fiche"
                                 :etablissement=selectedEtablissement
                                 :route="route"
                                 :attribut="attribut"
                                 @extended="setExtended"
                                 @fullscreen="setFullscreen"
                                 @status="updateStatus"
                                 @updated="etablissementUpdated"
                                 @selectItem = "selectItem">
          </section-salaire-means>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('REGLEMENT_LIST')">
        <slot name="section-reglement-list">
          <section-reglement-list ref="REGLEMENT_LIST"
                                  id="REGLEMENT_LIST"
                                  :extended="isExtended('REGLEMENT_LIST')"
                                  :showButton="true"
                                  :autoSave="true"
                                  :readOnly="readOnly"
                                  :moduleId="moduleId"
                                  :searchText="searchText"
                                  :ressourceHeader="ressource"
                                  :fiche="fiche"
                                  :etablissement=selectedEtablissement
                                  :route="route"
                                  :attribut="attribut"
                                  @extended="setExtended"
                                  @fullscreen="setFullscreen"
                                  @status="updateStatus"
                                  @toggleCardView="toggleCardView"
                                  @updated="transactionUpdated"
                                  @selectItem = "selectItem">
          </section-reglement-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ETABLISSEMENT_LOGO')">
        <slot name="section-etablissement-logo">
          <section-etablissement-logo ref="ETABLISSEMENT_LOGO"
                                      id="ETABLISSEMENT_LOGO"
                                      :extended="isExtended('ETABLISSEMENT_LOGO')"
                                      :showButton="true"
                                      :autoSave="true"
                                      :readOnly="readOnly"
                                      :moduleId="moduleId"
                                      :searchText="searchText"
                                      :ressourceHeader="ressource"
                                      :fiche="fiche"
                                      :etablissement=selectedEtablissement
                                      :route="route"
                                      :attribut="attribut"
                                      @extended="setExtended"
                                      @fullscreen="setFullscreen"
                                      @status="updateStatus"
                                      @updated="etablissementUpdated"
                                      @selectItem = "selectItem">
          </section-etablissement-logo>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ETABLISSEMENT_DOCUMENT_LIST')">
        <slot name="section-etablissement-document-list">
          <section-etablissement-document-list ref="ETABLISSEMENT_DOCUMENT_LIST"
                                               id="ETABLISSEMENT_DOCUMENT_LIST"
                                               :extended="isExtended('ETABLISSEMENT_DOCUMENT_LIST')"
                                               :showButton="true"
                                               :autoSave="true"
                                               :readOnly="readOnly"
                                               :moduleId="moduleId"
                                               :searchText="searchText"
                                               :ressourceHeader="ressource"
                                               :fiche="fiche"
                                               :etablissement=selectedEtablissement
                                               :route="route"
                                               :attribut="attribut"
                                               @extended="setExtended"
                                               @fullscreen="setFullscreen"
                                               @status="updateStatus"
                                               @toggleCardView="toggleCardView"
                                               @updated="documentUpdated"
                                               @selectItem = "selectItem">
          </section-etablissement-document-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Etablissement from '@/extend/classes/Etablissement';
import Adresse from '@/extend/classes/Adresse';
import { storeAdresse } from '@/generated/stores';
import Attestation from '@/extend/classes/Attestation';
import { storeAttestation } from '@/generated/stores';
import AccidentTravail from '@/extend/classes/AccidentTravail';
import { storeAccidentTravail } from '@/generated/stores';
import Apprenti from '@/extend/classes/Apprenti';
import { storeApprenti } from '@/generated/stores';
import PaymentMeans from '@/extend/classes/PaymentMeans';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Owner from '@/generated/classes/Owner';
import Transaction from '@/extend/classes/Transaction';
import { storeTransaction } from '@/generated/stores';
import Document from '@/extend/classes/Document';
import { storeDocument } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionEtablissementIdentite from '@/extend/sections/SectionEtablissementIdentiteExtend.vue';
import SectionAdresse from '@/extend/sections/SectionAdresseExtend.vue';
import SectionEtablissementContacts from '@/extend/sections/SectionEtablissementContactsExtend.vue';
import SectionEtablissementAffiliations from '@/extend/sections/SectionEtablissementAffiliationsExtend.vue';
import SectionEtablissementCaisses from '@/extend/sections/SectionEtablissementCaissesExtend.vue';
import SectionDemandeAttestationList from '@/extend/sections/SectionDemandeAttestationListExtend.vue';
import SectionAccidentTravailList from '@/extend/sections/SectionAccidentTravailListExtend.vue';
import SectionGestionnairesPaie from '@/custom/sections/SectionGestionnairesPaie.vue';
import SectionApprentiList from '@/extend/sections/SectionApprentiListExtend.vue';
import SectionPaymentMeansList from '@/extend/sections/SectionPaymentMeansListExtend.vue';
import SectionAbonnement from '@/custom/sections/SectionAbonnement.vue';
import SectionPrelevMeans from '@/extend/sections/SectionPrelevMeansExtend.vue';
import SectionSalaireMeans from '@/extend/sections/SectionSalaireMeansExtend.vue';
import SectionReglementList from '@/extend/sections/SectionReglementListExtend.vue';
import SectionEtablissementLogo from '@/extend/sections/SectionEtablissementLogoExtend.vue';
import SectionEtablissementDocumentList from '@/extend/sections/SectionEtablissementDocumentListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionEtablissementIdentite,
    SectionAdresse,
    SectionEtablissementContacts,
    SectionEtablissementAffiliations,
    SectionEtablissementCaisses,
    SectionDemandeAttestationList,
    SectionAccidentTravailList,
    SectionGestionnairesPaie,
    SectionApprentiList,
    SectionPaymentMeansList,
    SectionAbonnement,
    SectionPrelevMeans,
    SectionSalaireMeans,
    SectionReglementList,
    SectionEtablissementLogo,
    SectionEtablissementDocumentList,
    FicheHeader,
  },

  props: {
    etablissement: {
      type: Object as PropType<Etablissement>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.ETABLISSEMENT,
      sections: [
        'ETABLISSEMENT_IDENTITE',
        'ADRESSE',
        'ETABLISSEMENT_CONTACTS',
        'ETABLISSEMENT_AFFILIATIONS',
        'ETABLISSEMENT_CAISSES',
        'DEMANDE_ATTESTATION_LIST',
        'ACCIDENT_TRAVAIL_LIST',
        'GESTIONNAIRES_PAIE',
        'APPRENTI_LIST',
        'PAYMENT_MEANS_LIST',
        'ABONNEMENT',
        'PRELEV_MEANS',
        'SALAIRE_MEANS',
        'REGLEMENT_LIST',
        'ETABLISSEMENT_LOGO',
        'ETABLISSEMENT_DOCUMENT_LIST',
      ],

      toggleResetFormeJuridiqueSelect: false,
      toggleResetBrancheSelect: false,
      toggleResetConventionBrancheList: false,
      toggleResetTrancheEffectifSelect: false,
      adresse: new Adresse(),
      toggleResetPaysSelect: false,
      toggleResetCaisseSelectComplementaire: false,
      attestation: new Attestation(),
      accidentTravail: new AccidentTravail(),
      apprenti: new Apprenti(),
      transaction: new Transaction(),
      document: new Document(),
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_ETABLISSEMENT);
    },

    selectedEtablissement (): Etablissement {
      return this.etablissement
    },
    selectedAdresse (): Adresse {
      if (this.etablissement.adresseId == 0) {
        return storeAdresse.createNewAdresse();
      } else {
        return storeAdresse.getAdresse(this.etablissement.adresseId);
      }
    },

    owner (): Owner {
      const owner = new Owner();
      owner.objType =  ObjTypes.ETABLISSEMENT;
      owner.objId = this.etablissement.id;
      return owner;
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    etablissementUpdated (etablissement: Etablissement) {
    // To implement
    },

    // eslint-disable-next-line
    adresseUpdated (adresse: Adresse) {
    // To implement
    },

    // eslint-disable-next-line
    attestationUpdated (attestation: Attestation) {
    // To implement
    },

    // eslint-disable-next-line
    accidentTravailUpdated (accidentTravail: AccidentTravail) {
    // To implement
    },

    // eslint-disable-next-line
    apprentiUpdated (apprenti: Apprenti) {
    // To implement
    },

    // eslint-disable-next-line
    transactionUpdated (transaction: Transaction) {
    // To implement
    },

    // eslint-disable-next-line
    documentUpdated (document: Document) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.etablissement || this.etablissement.id < 0) && value == 'ETABLISSEMENT_IDENTITE') {
        this.setExtended(new Extended('ETABLISSEMENT_IDENTITE', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
